<template>
    <div class="mt-70">
    <app-header></app-header>
		<v-container fluid grid-list-lg pa-5 mt-2>
            <v-layout row wrap justify-center align-center fill-height mb-0>
                <v-flex lg12 sm12 xs12 md10 class="text-xs-center">
                    <!-- <v-card flat class="mx-5"> -->
                                <div class="font-24">Contact us</div>
                    <!-- </v-card> -->
                </v-flex>
                <v-flex xs12 sm12 md10 mt-3>
                    <v-layout wrap>
                         <v-flex xs12 sm6 md12>
                                <v-card flat class="px-3 py-3">
                                    <v-list>                                   
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title class="f-700">Existing Investors</v-list-tile-title>
                                        <v-list-tile-sub-title class="mt-1 font-12">Speak write to <a href="mailto:ir@iob.vc">ir@iob.vc.</a> You can also speak directly to our support team <a href="https://t.me/iob_llc" target="_blank">via Telegram</a></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title class="f-700">Potential Investors</v-list-tile-title>
                                        <v-list-tile-sub-title class="mt-1 font-12">For more information, please write to us at <a href="mailto:ir@iob.vc">ir@iob.vc</a>. You can find more information about our upcoming TAOs at <a :href="domainName+'/#/ir'">Investor Relations</a>.</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                        <v-list-tile-title class="f-700">Media & Press</v-list-tile-title>
                                        <v-list-tile-sub-title class="mt-1 font-12">For our media package, media events or to book a speaking engagement, please email us at <a href="mailto:media@iob.vc">media@iob.vc</a>.</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    </v-list>                                                      
                                </v-card>
                            </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md10>
                    <v-layout row wrap mt-5 mb-5>
                        <v-flex xs12 sm12 md3>
                            <v-img src="https://images.iob.community/SIP/material/website/contact/usa.jpg" height="300px">
                                <v-container fill-height fluid>
                                    <v-layout align-start column>
                                    <div  class="white--text pa-3 py-5">
                                        <div class="font-14 mt-2">
                                            IOB LLC
                                        </div>
                                        <div class="mt-2"> 
                                            1013 Centre Road, Suite 403-A Wilmington, DE 19805, USA (HQ)
                                        </div>
                                        <div class="mt-2">
                                            +1 775 476 8588
                                        </div>
                                        <div class="mt-2">
                                            <a href="mailto:usa@iob.vc">usa@iob.vc</a>
                                        </div>
                                    </div>
                                    </v-layout>
                                </v-container>
                            </v-img> 
                        </v-flex>
                        <v-flex xs12 sm12 md3>
                            <v-img src="https://images.iob.community/SIP/material/website/contact/shanghai.jpg" height="300px">
                            <v-container fill-height fluid>
                                <v-layout align-start column>
                                <div  class="white--text pa-3 py-5">
                                    <div class="font-14 mt-2">
                                        IOB Shanghai Ltd.
                                    </div>
                                    <div class="mt-2"> 
                                        Shanghai, China (Regional HQ)
                                    </div>
                                    <div class="mt-2">
                                        +1 775 476 8588
                                    </div>
                                    <div class="mt-2">
                                        <a href="mailto:china@iob.vc">china@iob.vc</a>
                                    </div>
                                </div>
                                </v-layout>
                            </v-container>
                             </v-img> 
                        </v-flex>
                        <v-flex xs12 sm12 md3>
                            <v-img src="https://images.iob.community/SIP/material/website/contact/germany.jpg" height="300px">
                            <v-container fill-height fluid>
                                <v-layout align-start column>
                                <div  class="white--text pa-3 py-5">
                                    <div class="font-14 mt-2">
                                        IOB Mesh Technology
                                    </div>
                                    <div class="mt-2"> 
                                        Hildeboldplatz 15-17, 50672, Cologne, Germany (Regional HQ)
                                    </div>
                                    <div class="mt-2">
                                        +49 172 261 2031
                                    </div>
                                    <div class="mt-2">
                                        <a href="mailto:germany@iob.vc">germany@iob.vc</a>
                                    </div>
                                </div>
                                </v-layout>
                            </v-container>
                            </v-img> 
                        </v-flex>              
                        <v-flex xs12 sm12 md3>
                            <v-img src="https://images.iob.community/SIP/material/website/contact/london.jpg" height="300px">
                            <v-container fill-height fluid>
                                <v-layout align-start column>
                                <div  class="white--text pa-3 py-5">
                                    <div class="font-14 mt-2">
                                        IOB London
                                    </div>
                                    <div class="mt-2"> 
                                        Hyde House, Edgware Road, London NW9, UK (Investment Services)
                                    </div>
                                    <div class="mt-2">
                                        +44 794 110 9962
                                    </div>
                                    <div class="mt-2">
                                        <a href="mailto:uk@iob.vc">uk@iob.vc</a>
                                    </div>
                                </div>
                                </v-layout>
                            </v-container>
                            </v-img> 
                        </v-flex>
                    </v-layout>     
                </v-flex>
            </v-layout>
		</v-container>

    </div>
</template>
<style>

</style>



<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                 domainName: config.ip
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {

        },
    }
</script>


// WEBPACK FOOTER //
// Contact.vue?1ded3711